export const EXPENSE_TYPES = [
	{
		value: 'costs_of_good_sold',
		label: $localize`:@@expenses_category.costs_of_good_sold:Costs of Good sold`,
		categories: [
			{ value: 'handling_fees', label: $localize`:@@expenses_category.handling_fees:Handling fees` },
			{ value: 'materials', label: $localize`:@@expenses_category.raw_materials:Materials` },
			{ value: 'resources', label: $localize`:@@expenses_category.resources:Resources` }
		]
	},
	{
		value: 'general_and_administrative',
		label: $localize`:@@expenses_category.general_and_administrative:General & Administrative`,
		categories: [
			{ value: 'marketing', label: $localize`:@@expenses_category.marketing:Marketing` },
			{ value: 'memberships_subscriptions', label: $localize`:@@expenses_category.memberships_subscriptions:Memberships/Subscriptions` },
			// { value: 'misc', label: $localize`:@@expenses_category.misc:Misc` },
			{ value: 'other', label: $localize`:@@expenses_category.other:Others` },
			{ value: 'rent', label: $localize`:@@expenses_category.rent:Rent` },
			{ value: 'salary_wages', label: $localize`:@@expenses_category.salary_wages:Salary/ Wages` },
			{ value: 'stationary', label: $localize`:@@expenses_category.stationary:Stationary` },
			{ value: 'utilities', label: $localize`:@@expenses_category.utilities:Utilities` },
		]
	}
];